import { isString } from 'lodash';

export const makeClassNameSafe = (className?: string) => {
  if (!isString(className)) return className;
  // Replace all unsafe characters with a dash
  return className.replace(/[^a-zA-Z0-9_-]/g, '-');
};
